// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GiftsPage_wrapper__2bCOS","content":"GiftsPage_content__xqIo_"};